import { Link } from "@chakra-ui/react";
import { Link as RouterLink } from "react-router-dom";

import {
  PageHeader,
  PageHeaderBackLink,
  PageHeaderSubtitle,
  PageHeaderTitle,
} from "src/layout/PageHeader";

type PageHeaderProps = {
  statusCode: number;
  statusText: string;
};

const PageHeaderError = ({ statusCode, statusText }: PageHeaderProps) => {
  return (
    <PageHeader>
      <PageHeaderBackLink>
        <Link as={RouterLink} onClick={() => window.history.back()}>
          &#8249; Back
        </Link>
      </PageHeaderBackLink>
      <PageHeaderTitle>{`${statusCode} - ${statusText}`}</PageHeaderTitle>
      <PageHeaderSubtitle>
        {
          "Please check to ensure you're on the correct page, or try again later."
        }
      </PageHeaderSubtitle>
    </PageHeader>
  );
};

export default PageHeaderError;
